import { $elementChild, $elementChildren } from "@grindex-common/helpers/elements";

export default class ModuleElementsBase {
	constructor($module) {
		this.$module = $module;
		this.elementMapSingle = [];
		this.elementMapMultiple = [];
	}

	_childElement(selector) {
		if (!this.elementMapSingle[selector]) {
			this.elementMapSingle[selector] = $elementChild(this.$module, selector);
		}

		return this.elementMapSingle[selector];
	}

	_childElements(selector, forceRefresh) {
		if (forceRefresh) {
			this.elementMapMultiple[selector] = $elementChildren(this.$module, selector);
		} else if (!this.elementMapMultiple[selector]) {
			this.elementMapMultiple[selector] = $elementChildren(this.$module, selector);
		}

		return this.elementMapMultiple[selector];
	}
}
